import { h, Component } from 'preact';
import { route } from 'preact-router';
import { Loading, UnauthorizedError } from 'lib/mkjs';
import { MyIdentity } from "entities/contactidentity";
import NewsFeed from '../elements/newsfeed';
import { WelcomeMessage } from '../elements/welcomemessage';
import { ImportStart } from '../elements/importer';
import LandingHome from './landing';
import ConnectionRequestView from '../elements/connectionrequest';
import { ContactListPage } from '../elements/addressbook';
import { MyContactInfoView, ContactInfoPage, ConnectionPage, PersonalContactView, getVerifyIdentityUrl } from '../elements/contactview';

class Home extends Component {

	render() {
		if (this.props.isLoading) {
			return <Loading />
		} else if (!this.props.currentUser) {
			return <LandingHome />
		}
		return <section>
			<WelcomeMessage {...this.props} />
			<ContactListPage {...this.props} />
		</section>
	}
}

class MyProfilePage extends Component {
	render() {
		if (this.props.contactEntity) {
			return <MyContactInfoView {...this.props} id={this.props.contactEntity.contactInfo.id} />
		} else if (this.props.isLoading || this.props.isLoadingContactEntity) {
			return <Loading />
		} else {
			return <UnauthorizedError />
		}
	}
}

function getRouterPages(props, loadCurrentUser, success) {
	return [
		<Home {...props} path="/" />,
		<PersonalContactView {...props} creating path="/create"/>,
		<ImportStart {...props} creating path="/import" />,
		<ContactInfoPage {...props} path="/contacts/:id" />,
		<PersonalContactView {...props} edit path="/contacts/:id/edit" />,
		<ConnectionRequestView {...props} path="/contacts/:contactId/request" />,
		<ConnectionPage {...props} path="/connections/:id" />,
		<NewsFeed {...props} path="/feed" />,
		<MyProfilePage {...props} path="/me" onUpdate={()=>{loadCurrentUser(); success('Your profile\'s been updated!','/me')}} />,
		<MyIdentity {...props} loadCurrentUser={loadCurrentUser} path="/me/verify/:type/:identifier" />,
	]
}

export {
	getRouterPages
}



// WEBPACK FOOTER //
// ./components/pages/index.js